import {
  GET_MESSAGE_GROUPS_REQ,
  GET_MESSAGE_GROUPS_SUCCESS,
  GET_MESSAGE_GROUPS_FAIL,
  GET_OVERALL_MESSAGE_GROUPS_SUCCESS,
  GET_OVERALL_MESSAGE_GROUPS_FAIL,
  CREATE_MESSAGE_GROUP_REQ,
  CREATE_MESSAGE_GROUP_SUCCESS,
  CREATE_MESSAGE_GROUP_FAIL,
  CREATE_MESSAGE_GROUP_RESET,
  UPDATE_MESSAGE_GROUP_REQ,
  UPDATE_MESSAGE_GROUP_SUCCESS,
  UPDATE_MESSAGE_GROUP_FAIL,
  UPDATE_MESSAGE_GROUP_RESET,
  DELETE_MESSAGE_GROUP_REQ,
  DELETE_MESSAGE_GROUP_SUCCESS,
  DELETE_MESSAGE_GROUP_FAIL,
} from "../constants/messageGroups";

export const messageGroupReducer = (
  state = { messageGroups: [], skip: 0, limit: 10, totalPage: 0 },
  action
) => {
  switch (action.type) {
    case GET_MESSAGE_GROUPS_REQ:
      return { loading: true };
    case GET_MESSAGE_GROUPS_SUCCESS:
      // console.log("payload", action.payload);
      return {
        loading: false,
        messageGroups: action.payload?.body?.messageGroupsList || [],
        totalPage:
          action.payload?.body?.count % action.payload?.limit === 0
            ? action.payload?.body?.count / action.payload?.limit
            : parseInt(action.payload.body?.count / action.payload?.limit) + 1,
      };
    case GET_MESSAGE_GROUPS_FAIL:
      return { loading: false, error: action.payload };
    case GET_OVERALL_MESSAGE_GROUPS_SUCCESS:
      return { ...state, loading: false, allMessageGroups: action.payload };
    case GET_OVERALL_MESSAGE_GROUPS_FAIL:
      return { ...state, loading: false, error: action.payload };
    case CREATE_MESSAGE_GROUP_REQ:
      return { ...state, loading: true };
    case CREATE_MESSAGE_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        successCreate: true,
        // automationCreate: action.payload?.automations,
        messageGroupCreate: action.payload,
        messageGroups: [...state.messageGroups, action.payload].sort(function (
          a,
          b
        ) {
          return new Date(b.createdAt) - new Date(a.createdAt);
        }),
      };
    case CREATE_MESSAGE_GROUP_FAIL:
      return { ...state, loading: false, error: action.payload };
    case CREATE_MESSAGE_GROUP_RESET:
      return { ...state, loading: false, successCreate: false };
    case UPDATE_MESSAGE_GROUP_REQ:
      return { ...state, loading: true };
    case UPDATE_MESSAGE_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        successUpdate: true,
        messageGroups: state.messageGroups.map((messageGroup) =>
          messageGroup._id === action.payload._id
            ? action.payload
            : messageGroup
        ),
      };
    case UPDATE_MESSAGE_GROUP_RESET:
      return { ...state, loading: false, successUpdate: false };
    case UPDATE_MESSAGE_GROUP_FAIL:
      return { ...state, loading: false, error: action.payload };
    case DELETE_MESSAGE_GROUP_REQ:
      return { ...state, loading: true };
    case DELETE_MESSAGE_GROUP_SUCCESS:
      return {
        loading: false,
        successDelete: true,
      };
    case DELETE_MESSAGE_GROUP_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
